import { REACT_QUERY_KEYS } from '@/constants'

export const truckModelsQueryKeys = {
  all: [REACT_QUERY_KEYS.TRUCK_MODELS] as const,
  select: (tenantKey: string, dcId?: number, shippingDate?: string) =>
    [
      ...truckModelsQueryKeys.all,
      'select',
      tenantKey,
      dcId,
      shippingDate
    ] as const
}
